import * as React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../../../../theme';
import { BaseButton } from '../../../../../BaseComponents';
import {
	getExchangeAvailability,
	getIsAwaitingPaymentExchange,
	getIsOpenedLastExchange,
	getExchangeRequestRefuseAllowed
} from '../../../../../Checkout/store/order/selectors';

import { getIsLoadingByType } from '@entities/exchange';
import { ClearLastExchangeButton } from '@features/order/clear-last-exchange';
import { RefuseExchangeButton } from '@features/exchange/refuse-exchange';
import { useRouter } from '@shared/lib/router';

const ExchangeRequestControls: React.FC = () => {
	const { t } = useTranslation('Exchange');
	const { ExchangeRequestControls: theme } = useTheme('Widgets').Exchange;

	const isAwaitingPaymentExchange = useSelector(getIsAwaitingPaymentExchange);
	const isOpenedLastExchange = useSelector(getIsOpenedLastExchange);
	const requestRefuseAllowed = useSelector(getExchangeRequestRefuseAllowed);
	const isExchangeAvailable = useSelector(getExchangeAvailability);
	const isRefuseLoading = useSelector(getIsLoadingByType('refuse-exchange'));

	const showRefuseButton = isOpenedLastExchange && requestRefuseAllowed;
	const showPaymentButton = isAwaitingPaymentExchange && !isRefuseLoading;
	const showNewRequestButton = !isOpenedLastExchange && isExchangeAvailable && !isRefuseLoading;

	const router = useRouter();

	const onGoToPayment = () => {
		router.navigate('/exchange/payment');
	};

	return (
		<div className={theme.root}>
			{showRefuseButton && <RefuseExchangeButton />}

			{showPaymentButton && (
				<BaseButton variant="action" onClick={onGoToPayment}>
					{t('ExchangeRequestControls.Payment')}
				</BaseButton>
			)}

			{showNewRequestButton && <ClearLastExchangeButton label={t('ExchangeRequestControls.NewRequest')} />}
		</div>
	);
};

export default ExchangeRequestControls;
